import { useContext, useCallback } from 'react';
import { flushSync } from 'react-dom';
import { GuardianContext } from '../components/GuardianProvider';
import type { GuardianAgent } from '../components/message-composer/chat-context/selectors';

export const useSelectAgentAnimation = () => {
  const { setSelectedAgent } = useContext(GuardianContext);

  return useCallback(
    (agent: GuardianAgent) => {
      if (!agent.landingPage || !agent.isSelectable) {
        return;
      }
      if (document.startViewTransition) {
        document.startViewTransition(() => {
          flushSync(() => {
            setSelectedAgent(agent);
          });
        }) 
      }
      else {
        setSelectedAgent(agent);
      }
    },
    [setSelectedAgent]
  );
};
